module.exports = __webpack_public_path__ + "static/img/r51.0bf6cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/r51.jpg
// module id = q2Bj
// module chunks = 73